import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TeacherInterface from './components/TeacherInterface';
import DisplayPanel from './components/DisplayPanel';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/teacher" element={<TeacherInterface />} />
        <Route path="/display" element={<DisplayPanel />} />
        <Route path="/" element={<TeacherInterface />} />
      </Routes>
    </Router>
  );
}

export default App;














